import { createContext, useContext } from "react";
import type { TProjectContext } from "../types";

export const ProjectContext = createContext<TProjectContext | null>(null);

export function useProjectContext(): TProjectContext {
  const ctx = useContext(ProjectContext);
  if (!ctx) throw new Error("useProjectContext must be used inside ProjectGuard");
  return ctx;
}
